import * as Sentry from "@sentry/react";
import { createBrowserRouter as createBrowserRouterReactDom } from "react-router";

export const createBrowserRouter = Sentry.wrapCreateBrowserRouterV7(
  createBrowserRouterReactDom,
);
